export default __webpack_public_path__ + "static/layer781-b72711c26fbb6628a28546f91f00ac63.jpg";